import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { FunilVendaSelectModule } from '../../../funil-venda/select';
import { FunilVendaFaseSelectModule } from '../../../funil-venda/fase/select';
import { LeadFormContainerModule } from '../../../lead/form/container';
import { LeadTypeaheadModule } from '../../../lead/typeahead';
import { ClienteTypeaheadSharedModule } from '../../../../pessoa/cliente/typeahead';
import { NegocioFormInsertWizardComponent } from './negocio-form-insert-wizard.component';
import { NegocioFormInsertStepFunilComponent, NegocioFormInsertStepLeadComponent, NegocioFormInsertStepClienteComponent, NegocioFormInsertStepperComponent, NegocioFormInsertStepNegocioComponent } from './steps';
import { UsuarioSelectModule } from '../../../../usuario/select';
import { NegocioPrioridadeSelectModule } from '../../prioridade/select';
import { CampanhaSelectFormModule } from '../../../../campanhas/campanhas/components/select-form';


@NgModule({
    imports: [
        SharedModule,
        CdkStepperModule,
        FunilVendaSelectModule,
        FunilVendaFaseSelectModule,
        LeadTypeaheadModule,
        LeadFormContainerModule,
        ClienteTypeaheadSharedModule,
        UsuarioSelectModule,
        NegocioPrioridadeSelectModule,
        CampanhaSelectFormModule
    ],
    declarations: [
        NegocioFormInsertWizardComponent,
        NegocioFormInsertStepperComponent,
        NegocioFormInsertStepFunilComponent,
        NegocioFormInsertStepLeadComponent,
        NegocioFormInsertStepClienteComponent,
        NegocioFormInsertStepNegocioComponent
    ],
    exports: [
        NegocioFormInsertWizardComponent
    ]
})
export class NegocioFormInsertWizardModule { }
